import React from 'react';

function TextNormal(props: any) {

    return(
        <p>{props.text}</p>
    );
}

export default TextNormal;